import { render, staticRenderFns } from "./user_space.vue?vue&type=template&id=05c58bc8&scoped=true&"
import script from "./user_space.vue?vue&type=script&lang=js&"
export * from "./user_space.vue?vue&type=script&lang=js&"
import style0 from "./user_space.vue?vue&type=style&index=0&id=05c58bc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c58bc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05c58bc8')) {
      api.createRecord('05c58bc8', component.options)
    } else {
      api.reload('05c58bc8', component.options)
    }
    module.hot.accept("./user_space.vue?vue&type=template&id=05c58bc8&scoped=true&", function () {
      api.rerender('05c58bc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/open3d/user_space.vue"
export default component.exports